<template>
  <div 
    class="skeleton-box"
    :style="`
      width: ${width};
      height: ${height ? height : sizes[variant]};
    `"
    :class="{ 'animated': animated }" 
  />
</template>

<script>
  export default {
    name: 'SkeletonItem',
    props: {
      width: { default: '100%' },
      height: { default: '' },
      variant: { default: 'body' },
      animated: { default: true }
    },
    data: function() {
      return {
        sizes: {
          title: '30px',
          title2: '26px',
          heading: '24px',
          heading2: '22px',
          heading3: '20px',
          subtitle: '18px',
          body: '16px',
          body2: '14px',
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.skeleton-box {
  display: inline-block;
  height: 1em;
  position: relative;
  overflow: hidden;
  background-color: #f2f2f2;
  border-radius: 4px;
  border: none;
}

.animated {
   &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(#fff, 0) 0,
      rgba(#fff, 0.2) 20%,
      rgba(#fff, 0.5) 60%,
      rgba(#fff, 0)
    );
    animation: shimmer 2s infinite;
    content: '';
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/baseComponents/skeleton/SkeletonItem.vue